import { Button, Checkbox, Form, Input, message, Popconfirm, Space } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../server";
import { CloseCircleOutlined } from "@ant-design/icons";

const Token = ({ id, onClose }) => {
  const [item, setItem] = useState({ active: true, name: "Токен интеграции" });
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const getData = () => {
    if (id) {
      setLoading(true);
      serverFetch(`token/${id}`)
        .then(data => {
          setLoading(false);
          setItem(data);
          form.setFieldsValue(data);
        })
        .catch(e => {
          setLoading(false);
          message.error(e.userMessage);
        })
    }
    else form.setFieldsValue(item);
  }

  useEffect(getData, [id, form])

  const onValuesChange = (value) => {
      setItem({ ...item, ...value });
  }; 

  const onSave = () => {
    setLoading(true)
    serverFetch("token", { method: id ? "PUT" : "POST", bodyData: item })
      .then(() => onClose(true))
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  }

  const onCancel = () => onClose()

  const onShowCode = () => {
    setLoading(true);
    serverFetch(`token/GetCode/${id}`)
      .then(code => {
        setLoading(false);
        setItem({...item, code});
        form.setFieldValue("code", code);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  const onDelete = () => {
    setLoading(true);
    serverFetch(`token/${id}`, { method: "DELETE" })
      .then(() => onClose(true))
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  }

  return<div className="sport-modal">
    <div className="sport-modal-overlay" onMouseDown={e => e.target === e.currentTarget && onClose(false)}>
      <div className="sport-modal-content" onMouseDown={e => e.stopPropagation()}>
        <div className="sport-modal-title"><span>Токен интеграции</span><CloseCircleOutlined className="sport-section-title-close" onClick={onCancel}/></div>
        <Form form={form} onValuesChange={onValuesChange} labelCol={{ span: 6 }} wrapperCol={{ span: 24 }} colon={false} disabled={loading}>
          <Form.Item name="active" valuePropName="checked" label=" "><Checkbox>Активный</Checkbox></Form.Item>
          <Form.Item label="Наименование" name="name"><Input /></Form.Item>
          {item?.code && <Form.Item label="Код" name="code"><Input readOnly /></Form.Item>}
          <Form.Item label=" ">
            <Space>
              <Button className="sport-btn" onClick={onShowCode} disabled={item?.code || !id}>Показать</Button>
              <Button className="sport-btn" onClick={onSave}>Сохранить</Button>
              <Popconfirm title="Подтверждение" description="Удалить?" onConfirm={onDelete}>
                <Button className="sport-btn">Удалить</Button>
              </Popconfirm>
              <Button className="sport-btn" onClick={onCancel}>Закрыть</Button>
            </Space>
          </Form.Item>
        </Form>
      </div>
    </div>
  </div>
}

export default Token;